export function arrayOfLength(length = 0) {
    const safeLength = Math.max(0, length);
    const ghostArray = Array.from(Array(safeLength));

    return ghostArray.map((_item, index) => index);
}

export function arrayShallowEquals(one: [], two: []) {
    return one.length === two.length && one.every((val, index) => val === two[index]);
}

export function arrayShuffle<T>(array: T[]): T[] {
    return array
        .map((item) => ({ sort: Math.random(), value: item }))
        .sort((one, two) => one.sort - two.sort)
        .map((item) => item.value);
}

export function arrayTrimFromEnd<T>(collection: T[], max = 0): T[] {
    return max > 0 ? collection.slice(-max) : collection;
}

export function mergeDeduplicatedArrays<T extends unknown[]>(...arrays: T[]) {
    return [...new Set([...arrays.flat()])];
}
